<section class="signing-layout">
  <div
    class="loading"
    [ngClass]="{ hidden: !loading }"
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div class="signing-layout__top">
    <div class="signing-layout__top-left">
      <div class="redr-logo">
        <img
          alt="cimb logo"
          src="assets/core/black-logo.svg"
        />
      </div>
      <div class="document-name">{{ document ? document.name : '' }}</div>
    </div>
    <div class="signing-layout__top-right">
      <button
        type="button"
        color="primary"
        mat-button
        (click)="download()"
      >
        <span>Download PDF</span>
      </button>
    </div>
  </div>
  <div class="signing-layout__content document-preview">
    <div
      #pdfContainerRef
      class="document-pdf document-preview__content"
    >
      <core-pdf-viewer [src]="contractPDF"></core-pdf-viewer>
    </div>
  </div>
</section>
